"use strict";

/**
 * Adjusts the width of a set of elements to match the width of the widest element.
 *
 * @param {jQuery} elements - A jQuery collection of elements whose widths need to be matched.
 * @returns {void}
 */
const matchWidth = (elements) => {
    const $elements = elements;

    if (!$elements.length) {
        return;
    }

    let maxWidth = 0;

    $elements.each(function () {
        const itemWidth = $(this).outerWidth();
        if (itemWidth > maxWidth) {
            maxWidth = itemWidth;
        }
    });

    // Apply the maximum width to all grid items
    $elements.css("width", maxWidth + "px");
};

module.exports = {
    matchWidth: matchWidth,
};
